import { faLocationDot } from '@fortawesome/pro-regular-svg-icons'
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation'
import { Card, Flex, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreBundleItemPayload } from '@flecto/types'
import { Badge, Icon, Modal } from '@flecto/ui'

export type ModalBundleItemsLocationProps = {
  bundleItems?: CoreBundleItemPayload[]
}

export function ModalBundleItemsLocation({
  bundleItems,
}: ModalBundleItemsLocationProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'items' })
  const { t: tActions } = useTranslation('shared', {
    keyPrefix: 'actions',
  })

  return (
    <Modal size='md'>
      <Modal.Icon
        color='red'
        icon={faCircleExclamation}
        mb={'md'}
        withCircleBackground
      />
      <Modal.Title>{t('bundle_location_modal_title')}</Modal.Title>
      <Modal.Subtitle>{t('bundle_location_modal_description')}</Modal.Subtitle>
      <Modal.Content>
        <Card withBorder>
          {bundleItems?.map((item, index) => (
            <Flex
              key={item.item_id}
              justify='space-between'
              mb={index !== bundleItems.length - 1 ? 'sm' : undefined}
            >
              <Text>{item.title}</Text>
              {item?.owner_address?.label && (
                <Badge color='red'>
                  <Icon size='sm' mr='sm' icon={faLocationDot} />
                  {item.owner_address.label}
                </Badge>
              )}
            </Flex>
          ))}
        </Card>
      </Modal.Content>
      <Modal.FooterExtra>
        <Text c='gray.6'>
          {' '}
          {t('new_bundle_modal_title_count', {
            count: bundleItems?.length,
            replace: { count: bundleItems?.length },
          })}
        </Text>
      </Modal.FooterExtra>
      <Modal.Cancel>{tActions('got_it')}</Modal.Cancel>
    </Modal>
  )
}
